// extracted by mini-css-extract-plugin
export default {"component":"ConferenceScreenComponent_component__C+GZ3"};